import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
import Progress from './Progress';
import { apiPath } from "../src/services/apiConfig";

function Speciality() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displaySpecility, setDisplaySpecility] = useState('none');
  const [displayUpdSpeciality, setDisplayUpdSpeciality] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [specialityName, setSpecialityName] = useState('');
  const [specialityDeptId, setSpecialityDeptId] = useState('');
  // const [uid, setUID] = useState('');
  const [specialityType, setSpecialityType] = useState('Surgical');
  const [isloading, setIsLoading] = useState(false)
  const [updSpecialityName, setSpecialityUpdName] = useState('');
  const [updSpecialityType, setSpecialityUpdType] = useState('');
  const [id, setID] = useState('');
  // const [uidErr, setUIDErr] = useState('');
  const [departmentDataStat, setDepartmentDataStat] = useState('')
  const [departmentData, setDepartmentData] = useState([])
  const [updSpecialityDepartmentId, setSpecialityUpdDepartmentId] = useState('');
  // const [Err, SetErr] = useState([]);
  const formRef = useRef();
  const [verfied, setVerfied] = useState(false);
  const [SpecialityHeading, setSpecialityHeading] = useState('');
  const [SpecialityCaption, setSpecialityCaption] = useState('');
  const [SpecialityPara1, setSpecialityPara1] = useState('');
  const [SpecialityPara2, setSpecialityPara2] = useState('');
  const [updSpecialityHeading, setSpecialityUpdHeading] = useState('');
  const [updSpecialityCaption, setSpecialityUpdCaption] = useState('');
  const [updSpecialityPara1, setSpecialityUpdPara1] = useState('');
  const [updSpecialityPara2, setSpecialityUpdPara2] = useState('');

  let txt = "";


  const handleSubmit = () => {
    verifySpecility()
    if (verfied) {
      formRef.current.reset();
    }
  }

  useEffect(() => {
    getSpecility()
    getDepartment()
  }, [])

  function openSpecility() {
    setDisplaySpecility('block')
  }

  function closeSpeciality() {
    setDisplaySpecility('none')
  }

  function openUpdSpeciality() {
    setDisplayUpdSpeciality('block')
  }

  function closeUpdUser() {
    setDisplayUpdSpeciality('none')
  }

  async function updateSpecility(id) {
    //alert(id+','+updSpecialityName+","+updSpecialityType+', '+ updSpecialityDepartmentId)

    let result = await fetch(apiPath + "updateSpeciality", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "name": updSpecialityName,
        "department_id": updSpecialityDepartmentId,
        "type": updSpecialityType,
        "heading": updSpecialityHeading,
        "caption": updSpecialityCaption,
        "about_para_1": updSpecialityPara1,
        "about_para_2": updSpecialityPara2
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)
    if (isloading) {
    } else {
      setIsLoading(false)
    }

    getSpecility()
  }

  async function deleteSpecility(id) {
    //alert('delete specility')
    let result = await fetch(apiPath + "specialities/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getSpecility()
  }



  async function updateOperation(id) {
    //alert(id)

    let result = await fetch(apiPath + "specialities/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },

      });

    result = await result.json();

    setSpecialityUpdType(result.data.type);
    setSpecialityUpdName(result.data.name);
    setSpecialityUpdDepartmentId(result.data.departmentId)
    setSpecialityUpdHeading(result.data.heading)
    setSpecialityUpdCaption(result.data.caption)
    setSpecialityUpdPara1(result.data.about_para_1)
    setSpecialityUpdPara2(result.data.about_para_2)
    setID(result.data.id)

    openUpdSpeciality();
  }


  function deleteOperation(id) {
    //alert(id)
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteSpecility(id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL SPECIALITY (for initial screen)*/ 

  async function getSpecility() {
    let result = await fetch(apiPath + "specialities",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value

    if (!item) {
      setUIDErr("required")
    } else {
 //     setUID(item)
    }
  }
  */}

  function verifySpecility() {
    setVerfied(true)
    addSpecility()
  }

  //*ADD A NEW SPECIUALITY*/ 
  async function addSpecility() {
    //   alert('Add,'+specialityName+','+specialityType)
    if (verfied) {
      setIsLoading(true)
      let result = await fetch(apiPath + "specialities", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": specialityName,
          "department_id": specialityDeptId,
          "type": specialityType,
          "heading": SpecialityHeading,
          "caption": SpecialityCaption,
          "about_para_1": SpecialityPara1,
          "about_para_2": SpecialityPara2
        })
      });
      result = await result.json();

      //alert('working....')

      if (isloading) {

      } else {
        //alert('Loaded')  
        setIsLoading(false)
      }

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)
      getSpecility()
    }
  }


  //* LIST OF ALL DEPARTMENT (for combo)*/ 

  async function getDepartment() {
    let result3 = await fetch(apiPath + "departments",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result3 = await result3.json();
    setDepartmentDataStat(result3.success);
    //  setSpecialityData(result2.data);
    if (result3.success === true) {
      setDepartmentData(result3.data);
    } else { setDepartmentData([]) }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">Role : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>

          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Specility Management</h4>
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openSpecility} type="button" name="button"
                className="btn solid round">Create Speciality</button>
            </div>
          </div>

          <div className="row mt16" >

            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border" width="25%">Id</th>
                  <th className="th-border left" width="15%">Name</th>
                  <th className="th-border left" width="15%">Department</th>
                  <th className="th-border left" width="20%">Heading</th>
                  <th className="th-border left" width="20%">Caption</th>
                  <th className="th-border left" width="25%">About Para 1</th>
                  <th className="th-border left" width="25%">About Para 2</th>
                  <th className="th-border left" width="10%">Type</th>
                  <th className="th-border" width="10%">Edit</th>
                  {/*                  <th className="th-border" width="10%">Delete</th>    */}
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="">{item.name}</td>
                          <td className="">{item.departmentName}</td>
                          <td className="">{item.heading}</td>
                          <td className="">{item.caption}</td>
                          <td className="">{item.about_para_1}</td>
                          <td className="">{item.about_para_2}</td>
                          <td className="">{item.type}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          {/*}                          <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>  */}
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW SPECIALITY */}

          <div id="newdept" style={{ 'display': displaySpecility }} className="cont__new-deptDetails">
            <form className="" action="" method="" ref={formRef} >
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeSpeciality}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add Specility</h2><br />
                  <div className="row">
                    <div className='c12-l-1'></div>
                    <div className='c12-l-5'>
                      <p style={{ 'fontSize': '0.75rem' }}>Department</p>
                      <select className="custom-select" onChange={(e) => setSpecialityDeptId(e.target.value)}>
                        {
                          (departmentDataStat === true ?
                            (
                              departmentData.map((item3, index) =>
                                <option value={item3.id} >{item3.name}</option>
                              ))
                            : <tr><td>No data</td></tr>)
                        }
                      </select>
                    </div>
                    <div className='c12-l-1'></div>
                    <div className='c12-l-5'>
                      <p style={{ 'fontSize': '0.75rem' }}>Specility Type</p>
                      <select className="custom-select" onChange={(e) => setSpecialityType(e.target.value)}>
                        <option value="Surgical" >Surgical</option>
                        <option value="Medical" >Medical</option>
                      </select>
                    </div>
                    <div className="c12-l-1"></div>
                    <div className="c12-l-11">

                      <p style={{ 'fontSize': '0.65rem' }}>Speciality Name</p>
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Specility Name" onChange={(e) => setSpecialityName(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>Heading</p>
                      <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="100" rows="3"
                        placeholder="Heading (maximum 100 Character)" onChange={(e) => setSpecialityHeading(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>Caption</p>
                      <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="350" rows="3"
                        placeholder="Caption (maximum 350 Character)" onChange={(e) => setSpecialityCaption(e.target.value)} />

                      <div className="row">
                        <div className="c12-l-1"><h3>About</h3></div>
                        <div className="c12-l-5">
                          <p style={{ 'fontSize': '0.65rem' }}>Para-1</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="4"
                            placeholder="Para-1 (maximum 500 Character)" onChange={(e) => setSpecialityPara1(e.target.value)} />
                        </div>
                        <div className="c12-l-1"></div>
                        <div className="c12-l-5">
                          <p style={{ 'fontSize': '0.65rem' }}>Para-2 (optional)</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="4"
                            placeholder="Para-2 (maximum 500 Character)" onChange={(e) => setSpecialityPara2(e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <button onClick={handleSubmit} type="button"
                    className="btn solid round">Add Specility</button>
                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING SPECIALITY */}

          <div id="newdept" style={{ 'display': displayUpdSpeciality }} className="cont__new-deptDetails">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Specility</h2><br />

                  <input type="hidden" value={id} />

                  <div className="row">
                    <div className='c12-l-1'></div>
                    <div className='c12-l-5'>
                      <p style={{ 'fontSize': '0.75rem' }}>Department</p>
                      <select className="custom-select" onChange={(e) => setSpecialityUpdDepartmentId(e.target.value)}
                        value={updSpecialityDepartmentId}>
                        {
                          (departmentDataStat === true ?
                            (
                              departmentData.map((item3, index) =>
                                <option value={item3.id} >{item3.name}</option>
                              ))
                            : <tr><td>No data</td></tr>)
                        }
                      </select>
                    </div>
                    <div className='c12-l-1'></div>
                    <div className='c12-l-5'>
                      <p style={{ 'fontSize': '0.75rem' }}>Speciality type</p>
                      <select className="custom-select" onChange={(e) => setSpecialityUpdType(e.target.value)}
                        value={updSpecialityType}>
                        <option value="Surgical" >Surgical</option>
                        <option value="Medical" >Medical</option>
                      </select>
                    </div>
                    <div className="c12-l-1"></div>
                    <div className="c12-l-11">
                      <p style={{ 'fontSize': '0.65rem' }}>Speciality Name</p>
                      <input type="text" className="box small" autoComplete="off"
                        placeholder="Name of the Speciality" onChange={(e) => setSpecialityUpdName(e.target.value)}
                        value={updSpecialityName} />

                      <p style={{ 'fontSize': '0.65rem' }}>Heading</p>
                      <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="100" rows="3"
                        placeholder="Heading (maximum 100 Character)" onChange={(e) => setSpecialityUpdHeading(e.target.value)}
                        value={updSpecialityHeading} />

                      <p style={{ 'fontSize': '0.65rem' }}>Caption</p>
                      <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="350" rows="3"
                        placeholder="Caption (maximum 350 Character)" onChange={(e) => setSpecialityUpdCaption(e.target.value)}
                        value={updSpecialityCaption} />

                      <div className="row">
                        <div className="c12-l-1"><h3>About</h3></div>
                        <div className="c12-l-5">
                          <p style={{ 'fontSize': '0.65rem' }}>Para-1</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="4"
                            placeholder="Para-1 (maximum 500 Character)" onChange={(e) => setSpecialityUpdPara1(e.target.value)}
                            value={updSpecialityPara1} />
                        </div>
                        <div className="c12-l-1"></div>
                        <div className="c12-l-5">
                          <p style={{ 'fontSize': '0.65rem' }}>Para-2 (optional)</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="4"
                            placeholder="Para-2 (maximum 500 Character)" onChange={(e) => setSpecialityUpdPara2(e.target.value)}
                            value={updSpecialityPara2} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <button onClick={() => { updateSpecility(id) }} type="button"
                    className="btn solid round">Update Speciality</button>
                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Speciality;
